import { ArrowRight } from 'lucide-react';
import * as React from 'react';
import { Link } from 'react-router';

import { HeroPatternNew } from '@/components/hero-pattern';
import { Button } from '@/components/ui/button';

import { cn } from '@/lib/utils';
import { pricing } from '@/pages/unauthenticated/pricing/components/constants';
import { TierCard } from '@/pages/unauthenticated/pricing/components/tier-card';

export function SectionPricing() {
  return (
    <section className="relative redesign-container py-12 md:py-24">
      <HeroPatternNew className="isolate" />
      <div className="mx-auto max-w-4xl text-center">
        <h2 className="text-base/7 font-semibold text-primary">Pricing</h2>
        <p className="mt-2 text-5xl font-bold tracking-tight text-balance sm:text-6xl">
          Less cash, more <span className="italic text-primary">flags</span>
        </p>
      </div>
      <p className="mx-auto mt-6 max-w-2xl text-center text-lg font-medium text-pretty text-muted-foreground sm:text-xl/8">
        Enjoy a 14-day free trial on all plans, no credit card required. Upgrade
        anytime with no minimum seat requirement.
      </p>
      <div className="isolate mx-auto mt-16 grid max-w-md grid-cols-1 gap-8 lg:mx-0 lg:max-w-none lg:grid-cols-3">
        {pricing.tiers.map((tier) => (
          <TierCard key={tier.activeTier} tier={tier} />
        ))}
      </div>
      <div className="mx-auto max-w-3xl text-center">
        <Button
          asChild
          variant="link"
          className={cn('w-fit mt-8 text-primary')}
        >
          <Link to="/pricing" className="inline-flex items-center">
            View more details
            <ArrowRight className="ml-2 w-4 h-4" />
          </Link>
        </Button>
      </div>
    </section>
  );
}
